<template>
    <v-col cols="2" class="pa-1 mt-2 text-center">
        <v-card color="grey lighten-4" outlined class="pa-2" style="border: 1px solid;">
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-img contain v-bind="attrs" v-on="on" height="100px" :src="icon">
                    </v-img>
                </template>
                <v-list :rounded="true" v-if="controller!=undefined && controller.addMenuItems().length>0">
                    <v-list-item  @click="controller.addWorkflowAction(item,mappedStep)" v-for="(item, index) in controller.addMenuItems()" :key="index">
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-card>
        <div class="action-description">{{ label }}</div>
    </v-col>
</template>

<script>
    export default {
        props: {
            label: String,
            icon: String,
            ctrl: String,
            mappedStep:Object
        },
        data() {
            return {
                controller: this.get_controller(this.ctrl).sections.workflow_step

            }
        },
        methods: {
      
        }
    }
</script>

<style scoped>
    .action-description {
        font-size: 14px;
        font-weight: bold;
        margin-top: 8px;
    }
</style>